const { __ } = wp.i18n;
const {
  registerBlockType,
  createBlock
} = wp.blocks
const {
  BlockControls,
  AlignmentToolbar,
  InspectorControls,
  RichText,
} = wp.blockEditor
const {
  TextControl,
  Button,
  Card,
  CardBody,
  PanelRow,
} = wp.components

const EditVideoPlayerHook = (props) => {

  // Lift info from props and populate various constants.
  const {
    attributes: {
      feedId,
      campaign
    },
    className,
    setAttributes
  } = props;

  const change = key => value => setAttributes({[key]:value})
  return [
    <InspectorControls>
      <Card>
        <CardBody>
            <TextControl
              label= 'Feed ID'
              value= {feedId}
              onChange= {change('feedId')}
            />
            <TextControl
              label= 'Campaign ID'
              value= {campaign}
              onChange= {change('campaign')}
            />
        </CardBody>
      </Card>
    </InspectorControls>
    ,
    <parone-video-block feed={feedId} campaign={campaign}/>
  ];
}

const SaveVideoPlayerHook = (props) => {
  const {
    attributes: {
      feedId,
      campaign
    },
    className
  } = props;

  return ( <parone-video-block feed={feedId} campaign={campaign}/>);
}

registerBlockType("parone/video-player", {
  title: __("ParOne Video Player", "parone"),
  icon: "analytics",
  category: "parone",
  attributes: {
    feedId: {
      type: "string",
      default: ""
    },
    campaign: {
      type: "string",
      default: ""
    },
  },
  edit: EditVideoPlayerHook,
  save: SaveVideoPlayerHook
});
